/**是否是符合规则的密码：密码必须是包含大写字母、小写字母、数字、特殊符号（#?!@$%^&*-.）的8位-16位的组合 */
export function isValidPassword(value) {
  return /^(?![A-Za-z0-9]+$)(?![a-z0-9#?!@$%^&*-.]+$)(?![A-Za-z#?!@$%^&*-.]+$)(?![A-Z0-9#?!@$%^&*-.]+$)[a-zA-Z0-9#?!@$%^&*-.]{8,16}$/.test(value)
}

/**是否是手机号 */
export function isPhone(value) {
  return /^1[3-9]\d{9}$/.test(value);
}

/** 是否是座机号（数字和`-`符号，必须包含数字，`-`不能出现在两端） */
export function isTele(value) {
  return /^[0-9]+(\-[0-9]+)*[0-9]+$/.test(value)
}